<template>
    <div class="float-aside">
        <el-aside>
            <h2>{{ $t('contactUS') }}</h2>
            <a href="javascript:;" @click="beforeRun(5, configInfo.whatsappLink)">
                <div class="phone"></div>
                <div>WhatsApp</div>
            </a>
            <a href="javascript:;" @click="beforeRun(1, configInfo.faceBookLink)">
                <div class="facebook"></div>
                <div>Facebook</div>
            </a>
            <a href="javascript:;" @click="beforeRun(2, configInfo.instagramLink)">
                <div class="creamer"></div>
                <div>Instagram</div>
            </a>
            <a href="javascript:;" @click="beforeRun(3, configInfo.linkedinLink)">
                <div class="inline"></div>
                <div>Linkedin</div>
            </a>
            <a href="javascript:;" @click="beforeRun(4, configInfo.tripadvisorLink)">
                <div class="recorder"></div>
                <div>Tripadvisor</div>
            </a>
            <a href="javascript:;" @click="beforeRunWecht(6)">
                <div class="wechat"></div>
                <div>{{ $t('wechat') }}</div>
            </a>
        </el-aside>

        <el-dialog
            :visible.sync="showQR"
            width="460px"
            custom-class="QR-box"
            :show-close="true"
            top="20vh"
            :lock-scroll="false"
        >
            <div class="QR-code">
                <div class="img">
                    <img src="@/assets/Header-Logo.webp" alt="logo" />
                </div>
                <p>{{ $t('WechatText') }}</p>
                <div class="QR-img">
                    <img :src="configInfo.weChatQRCode" alt="二维码" />
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    data() {
        return {
            showQR: false,
        }
    },
    methods: {
        // 侧边栏跳转之前执行的函数
        beforeRun(receptionType, receptionUrl) {
            this.$store.dispatch('receptionSave/visitsNum', {
                receptionType,
                receptionUrl,
            })
        },
        beforeRunWecht(receptionType) {
            this.showQR = true
            this.$store.dispatch('receptionSave/visitsNumWechat', {
                receptionType,
                receptionUrl: this.configInfo.weChat,
            })
        },
    },
    computed: {
        ...mapState({
            token: state => state.login.token,
            configInfo: state => state.baseConfig.baseConfigInfo,
        }),
    },
}
</script>

<style lang="scss" scoped>
.float-aside {
    .el-aside {
        position: fixed;
        right: 0;
        top: 30vh;
        z-index: 200;
        width: 125px !important;
        height: 250px;
        border-radius: 20px 0 0 20px;
        opacity: 1;
        // border: 1px solid #ffcc69;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        overflow: hidden;
        background: #fff;
        padding: 0;
        border: 2px solid #fff;
        border-right: none;
        padding-bottom: 10px;
    }
    .el-aside {
        text-align: center;
        background-color: #fccb64;
    }
    .el-aside h2 {
        font-size: 16px;
        padding: 0;
        margin: 0;
        background-color: #020b3b;
        width: 100%;
        color: #fff;
        font-family: SegoeUI;
    }
    aside a {
        display: flex;
        align-items: center;
        width: 100%;
    }
    aside a div {
        color: #020b3b;
        display: flex;
        justify-content: center;
        font-size: 14px;
        font-family: SegoeUI;
    }
    aside a div:first-child {
        width: 50px;
        background-position: center;
    }
    aside:hover {
        cursor: pointer;
    }
    aside .facebook {
        width: 12px;
        height: 22px;
        background: url(@/assets/aside_icon1.webp) no-repeat;
    }

    aside .creamer {
        width: 22px;
        height: 22px;
        background: url(@/assets/aside_icon2.webp) no-repeat;
    }

    aside .inline {
        width: 22px;
        height: 22px;
        background: url(@/assets/aside_icon3.webp) no-repeat;
    }

    aside .recorder {
        width: 26px;
        height: 16px;
        background: url(@/assets/aside_icon4.webp) no-repeat;
    }

    aside .phone {
        width: 21px;
        height: 21px;
        background: url(@/assets/aside_icon5.webp) no-repeat;
    }
    aside .wechat {
        width: 25px;
        height: 20px;
        background: url(@/assets/aside_icon6.webp) no-repeat;
    }
}
::v-deep .QR-box {
    .el-dialog__headerbtn {
        font-size: 25px;
        top: 15px;
        right: 15px;
        .el-icon-close {
            color: #020b3b;
        }
    }
    .el-dialog__body {
        padding: 0 !important;
    }
    .el-dialog__header {
        padding: 0 !important;
    }
    .QR-code {
        width: 460px;
        height: 554px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .img {
            width: 240px;
            padding-top: 48px;
            padding-bottom: 50px;
            img {
                width: 100%;
            }
        }
        p {
            color: #020b3b;
            font-weight: bold;
            font-size: 20px;
            line-height: 30px;
            width: 387px;
            font-family: SegoeUI;
            text-align: center;
        }
        .QR-img {
            width: 224px;
            margin-top: 30px;
            img {
                display: block;
                width: 100%;
                height: auto;
                border: 7px solid #111c6a;
                object-fit: fill;
            }
        }
    }
}
</style>
